  function manageSharedSliders() {
  const sliders = [
    { selector: '.recommend__slider', slidesToShow: 4 },
    { selector: '.ranking__slider', slidesToShow: 5 },
    { selector: '.new-arrivals__slider', slidesToShow: 4 },
    { selector: '.staff_styling__slider', slidesToShow: 5 },
    { selector: '.news-slider-section__slider', slidesToShow: 5 }
  ];

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  sliders.forEach(({ selector, slidesToShow }) => {
    const $slider = $(selector);
    const isInited = $slider.hasClass('slick-initialized');

    if (isDesktop && !isInited) {
      $slider.slick({
        slidesToShow: slidesToShow,
        arrows: true,
        //mobileFirst: true,
        responsive: [
          { breakpoint: 768, settings: "unslick" },
          
        ]
      });
    } else if (!isDesktop && isInited) {
      $slider.slick('unslick');
    }
  });
}

// イベント登録（全タイミングに対応）
document.addEventListener('DOMContentLoaded', manageSharedSliders);
window.addEventListener('resize', manageSharedSliders);
document.addEventListener('shopify:section:load', manageSharedSliders);
document.addEventListener('shopify:section:reorder', manageSharedSliders);
document.addEventListener('shopify:section:select', manageSharedSliders);